exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__documentation___3v16S {\n  margin: 0px 15px 25px 15px;\n  padding: 10px 25px; }\n", ""]);

// exports
exports.locals = {
	"documentation": "style__documentation___3v16S"
};